import { useTranslation } from "react-i18next";
import type { TCitationObject } from "../../../../../services/api/instances/researchApi/types";
import { CitationCard } from "../CitationCard";
import styles from "./styles.module.css";

interface Props {
  citations: TCitationObject[];
  className?: string;
}

export const CitationsList = ({ citations, className }: Props) => {
  const { t } = useTranslation();
  return (
    <div className={styles["citation-list-container"]}>
      <h3 className={styles["citation-list-title"]}>
        {t("research.result_citation")}
      </h3>
      {citations.map((citation, index) => (
        <CitationCard key={index} indexNumber={index} citation={citation} />
      ))}
    </div>
  );
};
